import { register } from "@rill/loader";

register(
  {
    name: "nutritionPlans",
    meta: ["no-bust", "nutrition-plan"],
    ttl: "2 hours",
  },
  async ({ api }, { proxyAthlete }) => {
    const query = {
      limit: false,
      sort: { utcEndDate: -1 },
      proxyAthlete,
    };

    const res = await api("nutrition-plan", { query });
    const data = await res.json();
    return data.sort((a, b) => b.utcEndDate - a.utcEndDate);
  }
);

register(
  {
    name: "mealPlan",
    meta: ["no-bust", "meal-plan"],
    ttl: "2 hours",
  },
  async ({ api }, { mealPlanId, proxyAthlete }) => {
    const query = {
      proxyAthlete,
    };
    const res = await api(`meal-plan/${mealPlanId}`, { query });
    const data = await res.json();
    return data;
  }
);

register(
  {
    name: "mostUsedMealPlans",
    meta: ["no-bust", "food", "meal", "recipe"],
    ttl: "2 hours",
  },
  async ({ api, locals }) => {
    const {
      activeUserToRequest,
      usersOrganization = { organizationActiveUsers: [] },
    } = locals;
    const { _id, organizationId } = activeUserToRequest;
    const { organizationActiveUsers = [] } = usersOrganization;
    const organizationIds = organizationActiveUsers.map(({ _id }) => _id);
    const query = {
      coachId: _id,
      ...(organizationId && { organizationIds }),
    };

    const request = await api(`most-used-meal-plans`, { query });
    const response = await request.json();
    const data = response?.response || {
      recipesResults: [],
      foodsResults: [],
      mealsResults: [],
      allResults: [],
    };
    return data;
  }
);

register(
  {
    name: "foodsByCoach",
    meta: ["no-bust", "food"],
    ttl: "2 hours",
  },
  async ({ api, locals }) => {
    const { activeUserToRequest } = locals;
    const { _id } = activeUserToRequest;

    const query = {
      coachId: _id,
    };

    const request = await api("foods", { query });
    const response = await request.json();
    const data = response?.foods || [];
    return data;
  }
);

register(
  {
    name: "mealsByCoach",
    meta: ["no-bust", "meal"],
    ttl: "2 hours",
  },
  async ({ api, locals }) => {
    const { activeUserToRequest } = locals;
    const { _id } = activeUserToRequest;

    const query = {
      coachId: _id,
    };

    const request = await api("meals", { query });
    const response = await request.json();
    const data = response?.meals || [];
    return data;
  }
);

register(
  {
    name: "mealPlanIsTemplate",
    meta: ["no-bust", "meal-plan"],
    ttl: "2 hours",
  },
  async ({ api }, { mealPlanId }) => {
    const res = await api(`meal-plan-is-template/${mealPlanId}`);
    const data = await res.json();
    const { hasTemplate = false } = data;
    return hasTemplate;
  }
);

register(
  {
    name: "mealPlanTemplates",
    meta: ["no-bust", "meal-plan"],
    ttl: "2 hours",
  },
  async ({ api, locals }, { customLimit, customSkip, noPagination }) => {
    const { activeUserToRequest } = locals;
    const { _id } = activeUserToRequest;
    const query = {
      coachId: _id,
      customLimit,
      customSkip,
      noPagination,
    };
    const res = await api(`meal-plan-template`, { query });
    const data = await res.json();
    const { mealPlans = [] } = data;
    return mealPlans;
  }
);

register(
  {
    name: "assignedMealPlans",
    meta: ["no-bust", "meal-plan"],
    ttl: "2 hours",
  },
  async ({ api, locals }) => {
    const { activeUserToRequest } = locals;
    const { _id } = activeUserToRequest;
    const query = {
      coachId: _id,
    };
    const res = await api(`assigned-meal-plans`, { query });
    const data = await res.json();
    const { mealPlans = [] } = data;
    return mealPlans;
  }
);

register(
  {
    name: "mealPlanCount",
    meta: ["no-bust", "meal-plan"],
    ttl: "2 hours",
  },
  async ({ api, locals }) => {
    const { activeUserToRequest } = locals;
    const { _id } = activeUserToRequest;
    const query = {
      coachId: _id,
    };
    const res = await api(`meal-plan-template-count`, { query });
    const data = await res.json();
    const { mealPlanCount = 0 } = data;
    return mealPlanCount;
  }
);

register(
  {
    name: "customFoods",
    meta: ["no-bust", "food", "meal"],
    ttl: "2 hours",
  },

  async ({ api, locals }) => {
    const {
      activeUserToRequest,
      usersOrganization = { organizationActiveUsers: [] },
    } = locals;
    const { _id: ownerId } = activeUserToRequest;
    const { organizationActiveUsers = [] } = usersOrganization;
    const organizationIds = organizationActiveUsers.map(({ _id }) => _id);
    const query = {
      ownerId,
      organizationIds,
    };

    const request = await api(`meal-planner-custom-foods`, { query });
    const response = await request.json();
    const data = response?.data || [];
    return data;
  }
);
